<template>
  <div class="to-top cu" @click="scrollToTop">
    <img src="../../assets/index/top-prev.png" />
    <p>返回顶部</p>
  </div>
</template>
 
<script>
export default {
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动效果
      });
    },
  },
};
</script>
 
<style scoped>
@import url(../../../css/to-top-phone.min.css);
</style>


// WEBPACK FOOTER //
// src/components/mobile/MyTop.vue